import { navigate } from 'gatsby';
import React, { useContext } from 'react';
import { useLocation } from 'react-use';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';

import CenteredGridItemComponent from '@ui/molecules/CenteredGridItem/CenteredGridItem.component';

import FlowContext from '@providers/FlowContextProvider';

import theme from '@theme/FolxTheme';

const AppointmentErrorBox = styled(FlexColumn)`
	background-color: ${theme.colors.white};
	border-radius: ${theme.radius.lg};
	padding: ${theme.spacing.sm} ${theme.spacing.md};
	border: 1px solid ${theme.colors.red};
	width: 100%;
	gap: ${theme.spacing.sm};
	align-items: center;

	${Button} {
		width: auto;
	}

	${SubheadingText}, ${BasicText} {
		width: 100%;
	}
`;

export interface INewAppointmentConfirmationErrorContent {
	appointmentErrorHeader: string;
	appointmentErrorInfo?: string;
	rescheduleAppointmentButton: string;
}

interface INewAppointmentConfirmationErrorProps {
	pageContent: INewAppointmentConfirmationErrorContent;
}

// content available on new-member-next-steps butter page
export const NewAppointmentConfirmationError = ({
	pageContent,
}: INewAppointmentConfirmationErrorProps) => {
	const { appointmentErrorHeader, appointmentErrorInfo, rescheduleAppointmentButton } = pageContent;
	const { existingFormData } = useContext(FlowContext);

	const location = useLocation();

	return (
		<CenteredGridItemComponent>
			<AppointmentErrorBox>
				<SubheadingText>{appointmentErrorHeader}</SubheadingText>
				{appointmentErrorInfo && <BasicText>{appointmentErrorInfo}</BasicText>}
				<Button
					label={rescheduleAppointmentButton}
					onClick={() => {
						navigate(
							`/app/member/appointments/reschedule/${
								existingFormData?.paymentConfirmation || location.state?.cogsworthId
							}`
						);
					}}
				/>
			</AppointmentErrorBox>
		</CenteredGridItemComponent>
	);
};
